import type { Context } from '@ms-cloudpack/api-server';
import { createExpressApp, getDomain } from '@ms-cloudpack/create-express-app';
import { handleBundleRequest } from './handleBundleRequest.js';
import type { BundleServer } from './types/BundleServer.js';
import type { BundleServerOptions } from './types/BundleServerOptions.js';

/**
 * The bundle server handles package requests and returns bundled resources.
 * Resources are bundled on demand and cached locally to avoid re-bundling on each request.
 */
export async function startBundleServer(options: BundleServerOptions, context: Context): Promise<BundleServer> {
  const { config } = context.session;
  const domain = getDomain(config.server?.domain);
  const { app, port, close, url } = await createExpressApp({
    portRange: options.port ?? [5500, 5501, 5502, 5503],
    requireSpecifiedPort: !!options.port,
    hostname: domain,
    sslOptions: config.server?.https,
    cwd: config.appPath,
  });

  // Set up the express app routes.
  app.get('*', (req, res) => {
    handleBundleRequest({ req, res, ...options }, context).catch((err) => {
      console.error((err as Error)?.stack || err);
      res.status(500).send(`Error bundling: ${err}`);
    });
  });

  // Save the URL.
  context.session.urls.bundleServer = url;

  return { close, port, url };
}
